import { render } from "./TrasladosDisponibles.vue?vue&type=template&id=333cbbbb&scoped=true"
import script from "./TrasladosDisponibles.vue?vue&type=script&lang=js"
export * from "./TrasladosDisponibles.vue?vue&type=script&lang=js"

import "./TrasladosDisponibles.vue?vue&type=style&index=0&id=333cbbbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333cbbbb"]])

export default __exports__